<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'account.employeeProfile' | translate }}" [menuService]="tabMenuService"></app-header>

    <div class="profile-layout">
        <app-profile-card class="profile-layout-sidebar" [model]="employee"></app-profile-card>
        <div class="profile-layout-content">
            <!-- Account Information -->
            <ui-card class="profile-card" [withMargin]="false">
                <div class="profile-card-header">
                    <h2>{{ 'account.accountInformation' | translate }}</h2>
                    <ui-button type="link" (click)="currentlyOpenDialog = 'LANGUAGE'">{{
                        'edit' | translate
                    }}</ui-button>
                </div>
                <label>{{ 'account.accountCreated' | translate }}</label>
                <div>{{ account.createdAt | appDate: 'medium' }}</div>
                <label>{{ 'account.accountActivated' | translate }}</label>
                <div>{{ account.activatedAt | appDate: 'medium' }} UTC</div>
                <label>{{ 'account.language' | translate }}</label>
                <div>{{ employee.language }}</div>
            </ui-card>

            <!-- Password -->
            <ui-card class="profile-card" [withMargin]="false">
                <div class="profile-card-header">
                    <h2>{{ 'account.password' | translate }}</h2>
                    <ui-button type="link" (click)="currentlyOpenDialog = 'PASSWORD'">{{
                        'edit' | translate
                    }}</ui-button>
                </div>
                <label>{{ 'account.password' | translate }}</label>
                <div><ng-container *ngFor="let i of [].constructor(12)">&bull;</ng-container></div>
            </ui-card>

            <app-multi-factor-authentication class="d-contents" [account]="account" />

            <!-- Emails -->
            <ui-card *ngIf="emailsTable" class="emails-table" [withMargin]="false" [withSpacing]="false">
                <app-table
                    (menuItemSelected)="menuAction($event)"
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                    [showSearch]="false"
                    [useStickyHeader]="false"
                    [table]="emailsTable"
                    title="{{ 'account.emails' | translate }}"
                >
                </app-table>
                <ui-button class="add-email-button" type="link" (click)="currentlyOpenDialog = 'ADD_EMAIL'"
                    >&#43; {{ 'account.addNewEmail' | translate }}</ui-button
                >
            </ui-card>
        </div>
    </div>
</div>

<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'ADD_EMAIL'"
    [form]="addEmailForm.form"
    size="small"
    (primaryButtonPressed)="onAddEmail(addEmailForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="account.addEmail"
>
    <app-form-email #addEmailForm></app-form-email>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'PASSWORD'"
    [form]="editPasswordForm.form"
    size="small"
    (primaryButtonPressed)="onSavePassword(editPasswordForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="account.editPassword"
>
    <app-form-password #editPasswordForm></app-form-password>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'LANGUAGE'"
    [form]="editLanguageForm.form"
    size="small"
    (primaryButtonPressed)="onSaveLanguage(editLanguageForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="account.accountInformation"
>
    <app-form-language #editLanguageForm [employee]="employee"></app-form-language>
</ui-dialog>

<ui-confirmation-dialog
    #confirmDeleteEmail
    header="account.deleteEmail"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
>
    {{ 'account.areYouSureYouWantToDeleteThisEmail' | translate }}
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #confirmMakePrimary
    header="account.setThisEmailAsYourPrimaryEmail"
    primaryButtonLabel="account.makePrimary"
    secondaryButtonLabel="cancel"
>
    {{ 'account.settingPrimaryEmail' | translate }}
</ui-confirmation-dialog>
